import { render, staticRenderFns } from "./wf-dropdown-select-display.vue?vue&type=template&id=5eff445d&scoped=true&"
import script from "./wf-dropdown-select-display.vue?vue&type=script&lang=ts&"
export * from "./wf-dropdown-select-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-dropdown-select-display.vue?vue&type=style&index=0&id=5eff445d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eff445d",
  null
  
)

export default component.exports